<template>
  <artmisads-modal title="Reject Reason" :visible="visible" @cancel="handleCancel" @ok="handleSave">
  <a-form :model="formData" :rules="rules" ref="formRef">
    <a-form-item label="Reject Reason" name="rejectionReason ">
      <a-textarea type="textarea" v-model:value="formData.rejectionReason" :maxlength="200"
      :auto-size="{ minRows: 3, maxRows: 5 }" allow-clear/>
    </a-form-item>
  </a-form>
</artmisads-modal>
</template>

<script setup>
import { ref,defineExpose,defineEmits } from 'vue'
import { financeApi } from '@/server/operator/finance'
import { message } from 'ant-design-vue'
const emit = defineEmits(['refresh'])
const visible = ref(false)
const formData = ref({
  rejectionReason : '',
  id: ''
})
const rules = ref({
  rejectionReason : [{ required: true, message: 'Please input reject reason' }]
})
const formRef = ref(null)
const handleCancel = () => {
  visible.value = false
}
const handleSave = () => {
  formRef.value.validate().then(res => {
    financeApi.placementReject(formData.value).then(res => {
      if(res){
        message.success('Reject Success!')
        visible.value = false
        emit('refresh')
      }
    })
  })
} 
const open = (id) => {
  formData.value.id = id
  formData.value.rejectionReason = ''
  visible.value = true
}
defineExpose({
  open
})
</script>

<style scoped>
</style>